<div class="item-container content-box d-flex flex-column">
    <div class="content-header mb-3">
        <div class="row">
            <div class="col-6 order-1 order-md-1  d-flex align-items-center">
                <h6 class="mb-0 ms-lg-4" *ngIf="!isEditSurvey">{{"COMMON.ADD" | translate}} {{"MENUITEMS.STAFFSURVEY.SURVEY" | translate}}</h6>
                <h6 class="mb-0 ms-lg-4" *ngIf="isEditSurvey">{{"COMMON.EDIT" | translate}} {{"MENUITEMS.STAFFSURVEY.SURVEY" | translate}}</h6>
            </div>
            <div class="col-6 order-1 order-md-1  d-flex align-items-center justify-content-end">
                <div (click)="onClose()"><i class="material-icons ms-4 ms-lg-5">close</i></div>
            </div>
        </div>
    </div>
    <div class="content-item item-content flex-grow-1 d-flex flex-column ">
        <div class="row  main-cont flex-grow-1  ">
            <div class=" col-12 card mb-0" *ngIf="!isSurveyDetailCompleted">
                <div class="card-body d-flex align-items-center justify-content-center">
                    <form class="flex-grow-1 f-box" [formGroup]="surveyForm" (ngSubmit)="onNext()">
                        <div class="text-center cursor-pointer">
                            <img src="assets/images/staff_survey.png" class="img-fluid">
                        </div>
                        <input type="text" class="form-control mt-3 mt-lg-4" formControlName="s_t" placeholder="{{'COMMON.ENTER' | translate}}  {{'COMMON.TITLE' | translate}} ">
                        <mat-error *ngIf="isControlHasError('s_t','required')">{{"COMMON.THR" |translate}}  </mat-error>
                            <div class="row">
                                <div class="col-md-6 mt-2 mt-md-3">
                                    <div>
                                        <label for="">{{"COMMON.STARTDATE"|translate}}</label>
                                        <div class="in-box">
                                            <input class="form-control in-i" [matDatepicker]="startDate" formControlName="st_dt"  readonly  
                                           />
                                            <mat-datepicker-toggle matIconSuffix [for]="startDate"  class="mat-date"></mat-datepicker-toggle>
                                            <mat-datepicker #startDate ></mat-datepicker>
                                        </div>
                                        <mat-error *ngIf="isControlHasError('st_dt','required')">{{"COMMON.THR" |translate}}  </mat-error>
                                    </div>
                                </div>
                                <div class="col-md-6 mt-2 mt-md-3">
                                    <label for="">{{"COMMON.ENDDATE"|translate}}</label>
                                    <div class="in-box">
                                        <input class="form-control in-i" [matDatepicker]="endDate" formControlName="ed_dt" readonly  [min]="surveyForm.value.st_dt"/>
                                        <mat-datepicker-toggle matIconSuffix [for]="endDate" class="mat-date"></mat-datepicker-toggle>
                                        <mat-datepicker #endDate ></mat-datepicker>
                                    </div>
                                    <mat-error *ngIf="isControlHasError('ed_dt','required')">{{"COMMON.THR" |translate}}  </mat-error>
                                    <mat-error *ngIf="surveyForm.hasError('startDtBeforeEndDt')">  {{"VALIDATION.GTZ"|translate}} </mat-error>
                                </div>
                            </div>
                            <div class="mt-2 mt-md-3">
                                <label for="">{{"COMMON.DESC"|translate}}</label>
                                <div>
                                   <textarea name="" class="form-control" cols="30" rows="3" formControlName="s_desc"></textarea>
                                </div>
                            </div>
                            <div class="mt-2 mt-md-3 toggle"><label class="mb-0 me-2">{{"COMMON.ACTIVE" | translate}}</label>
                                <mat-slide-toggle color="primary" class="mb-0" formControlName="active"></mat-slide-toggle></div>
                    </form>
                </div>
            </div>
            <div class="col-12  mb-0" *ngIf="isSurveyDetailCompleted">
                <div class="row ">
                    <div class="col-lg-7 mt-3 mt-lg-0 col-xl-8 d-flex flex-column">
                        <div class="card p-3 left-container flex-grow-1">
                            <div class="d-flex align-items-center mt-2  mb-4">
                                <i class="material-icons pe-2" (click)="onBack()">arrow_back</i>
                                <h6 class=" sentence-wrapper mb-0">{{surveyForm.value.s_t}}</h6>
                            </div>
                            <div class="surver-c">
                                <ng-container *ngTemplateOutlet="courseView"></ng-container>
                            </div>
                         
                        </div>
                    </div>
                    <div class="col-lg-5  mt-3 mt-xl-0 col-xl-4">
                           <ng-container *ngTemplateOutlet="mobileView"></ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="content-footer">
        <div class="text-center">
        <mat-error *ngIf="isError">{{error}}</mat-error></div>
        <div class="d-flex justify-content-end align-items-center  pb-xxl-2" *ngIf="!isSurveyDetailCompleted">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 " type="submit" (click)="onNext()">{{"BUTTON.NEXT"|translate}}</button>
        </div>
        <div class="d-flex justify-content-end align-items-center  pb-xxl-2" *ngIf="isSurveyDetailCompleted">
            <button type="button" class="btn auth-form-btn btn-outline-primary mt-3  me-3 align-items-center"  (click)="onClose()">
                {{"BUTTON.CANCEL" |translate}}</button>
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 " type="submit" (click)="onSave()">
                {{"BUTTON.SAVE"|translate}}</button>
        </div>
    </div>
</div>
<ng-template #courseView>
    <mat-accordion class="custom-mat-accordion" cdkDropList (cdkDropListDropped)="mainDrop($event)">
        <mat-expansion-panel cdkDrag hideToggle="true" [disabled]="true"
            *ngFor="let item of surveyArr;let i=index">
            <mat-expansion-panel-header class="ti-box">
                <mat-panel-title class="se-b d-flex justify-content-between">
                    <div class=" d-flex align-items-center">
                        <div class="drag-img me-3 d-none d-sm-flex ">
                            <img src="assets/images/icons/drag_drop.png" class="img-fluid" alt="">
                        </div>
                        <div class="survey-cont d-flex align-items-center">
                          <div class="s-img me-2">
                            <img *ngIf="item.type=='description'" src="assets/images/forms/description_ic.svg" class="img-fluid" alt="">
                            <img *ngIf="item.type=='dropdown'"src="assets/images/forms/dropdown_ic.svg" class="img-fluid" alt="">
                            <img *ngIf="item.type=='open_ended'"src="assets/images/forms/open_ended_ic.svg" class="img-fluid" alt="">
                            <img *ngIf="item.type=='rating'" src="assets/images/forms/rating_ic.svg" class="img-fluid" alt="">
                            <img *ngIf="item.type=='numeric_range'" src="assets/images/forms/numeric_range.svg" class="img-fluid" alt="">
                            <img *ngIf="item.type=='yes_no'" src="assets/images/forms/yes_no.svg" class="img-fluid" alt="">
                            <img *ngIf="item.type=='opinion_scale'" src="assets/images/forms/opinion_scale.svg" class="img-fluid" alt="">
                          </div>
                          <div *ngIf="item.type!='description'" class="clamp-line-1">{{item.su_q}}</div>
                          <div *ngIf="item.type=='description'" class="desc-box" [innerHTML]="item.desc|truncate:30:'desc'"></div>
                        </div>                     
                    </div>
                    <div class="icons-box ti-ic-b ">
                        <div class="action-icon me-2 " (click)="onEditItem($event,item,i)">
                            <img src="assets/images/icons/edit-icon.svg" alt="" class="img-fluid">
                        </div>
                        <div class="action-icon me-2 " (click)="onCopyItem($event,item)">
                            <i class="material-icons coppy-icon">content_copy</i>
                        </div>
                        <div class="action-icon me-2 " (click)="onDeleteItem($event,i)">
                            <img src="assets/images/icons/delete-icon.svg" alt="" class="img-fluid">
                        </div>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>          
        </mat-expansion-panel>
        <div class="add-section d-flex align-items-center justify-content-center mt-3 mt-lg-4" (click)="onAddField()">
            <i class="material-icons me-2 add-obj">add</i>{{"COMMON.ADDNEWFIELD" | translate}}
        </div>
    </mat-accordion>
</ng-template>
<ng-template #mobileView>
    <div class="d-flex justify-content-center ">
        <div class="mobile-container ">
            <div class="mob-header py-3 d-flex">
                <span class="sentence-wrapper mx-2">{{surveyForm.get('s_t')?.value }}</span>
                <div class="mobile-curve"><img src="assets/images/apps/mobile_header_curve.png" alt=""></div>
            </div>
            <div class="mobile-content">
                <div class="m-con-box" *ngFor="let item of surveyArr">
                    <div class="m-b-cont open-box radio-cont" *ngIf="item.type=='opinion_scale'">
                          <div class="">
                            <img src="assets/images/icons/smiley.png" class="img-fluid" alt="">
                          </div>
                          <div class="open-con text-bold text-black mt-2">{{item.su_q}}</div>
                          <div class="open-con ">{{item.desc}}</div>
                          <div class="d-flex op-b justify-content-space-around mt-2" >
                             <div *ngFor="let item of opinionScaleArr;" class="o-i">{{item}}</div>                            
                         </div>
                          <div class="d-flex justify-content-between mt-2">
                            <div class="v-item">{{"COMMON.POOR" | translate}}</div>
                            <div class="v-item">{{"COMMON.EXCELLENT" | translate}}</div>
                          </div>
                    </div>
                    <div class="m-b-cont open-box radio-cont" *ngIf="item.type=='rating'">
                        <div class="open-con text-bold text-black">{{item.su_q}}</div>
                        <div class="open-con ">{{item.desc}}</div>
                        <div class="divider  mt-2 mb-2"></div>
                        <div class="rating">
                            <ngb-rating [(rate)]="currentRate" [max]="item.q_dt">
                                <ng-template let-fill="fill" let-index="index">
                                    <i class="bi-star{{fill === 100 ? '-fill' : ''}}" [class.filled]="fill === 100" [class.low]="index < 2"></i>                              
                                </ng-template>
                            </ngb-rating>
                        </div>                     
                        <div class="d-flex justify-content-between mt-2">
                            <div class="v-item">{{"COMMON.VERYBAD" | translate}}</div>
                            <div class="v-item">{{"COMMON.VERYGOOD" | translate}}</div>
                        </div>
                    </div>
                    <div class="m-b-cont desc-box text-center" *ngIf="item.type=='description'" [innerHTML]="item.desc"></div>
                    <div class="m-b-cont open-box" *ngIf="item.type=='open_ended'">
                        <div class="open-con text-bold text-black">{{item.su_q}}</div>
                        <div class="open-con ">{{item.desc}}</div>
                        <div class="divider  mt-2 mb-3"></div>
                        <input type="text" class="form-control  mb-2" placeholder="{{'COMMON.TYPEHERE' | translate}}">
                    </div>
                    <div class="m-b-cont open-box radio-cont" *ngIf="item.type=='dropdown'">
                        <div class="open-con text-bold text-black">{{item.su_q}}</div>
                        <div class="open-con ">{{item.desc}}</div>
                        <div class="divider  my-2"></div>
                        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group align-items-start">
                        <mat-radio-button class="example-radio-button ms-0" *ngFor="let val of item.q_dt" [value]="val.val">
                          {{val.val}}
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div class="m-b-cont open-box radio-cont" *ngIf="item.type=='yes_no'">
                        <div class="open-con text-bold text-black">{{item.su_q}}</div>
                        <div class="open-con ">{{item.desc}}</div>
                        <div class="divider  my-2"></div>
                        <div class="d-flex justify-content-center">
                            <button type="button" class="btn btn-outline-primary d-flex  align-items-center me-2 btn-icon" >
                                <i class="material-icons me-2">thumb_up</i>{{"COMMON.YES" |translate}}</button>
                            <button type="button" class="btn btn-outline-primary d-flex  align-items-center btn-icon"  >
                                <i class="material-icons me-2">thumb_down</i>{{"COMMON.NO" |translate}}</button>
                        </div>
                    </div>
                    <div class="m-b-cont open-box radio-cont" *ngIf="item.type=='numeric_range'">
                        <div class="open-con text-bold text-black">{{item.su_q}}</div>
                        <div class="open-con ">{{item.desc}}</div>
                        <div class="divider  my-2"></div>
                        <mat-slider [min]="item.min" [max]="item.max"  discrete  [displayWith]="formatLabel" class="mt-4">
                            <input [value]="item.min" matSliderStartThumb>
                            <input [value]="item.max" matSliderEndThumb>
                        </mat-slider>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<app-loading-spinner></app-loading-spinner>